import { Platform } from 'react-native';

/**
 * Trigger a browser "Save as…" for a Blob fetched through the authenticated API
 * (issue #248 — downloading raw import-batch files for dev re-upload / audit).
 *
 * Web-only: an `<a download>` click preserves the server-supplied filename
 * better than opening a blob URL in a new tab. On native this is a no-op (the
 * raw-file download is a desktop workflow) — callers should only surface the
 * button on web.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
	if (Platform.OS !== 'web' || typeof document === 'undefined' || typeof URL === 'undefined' || !URL.createObjectURL) return;
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	// Revoke after the click is processed — revoking synchronously can cancel the
	// download in some browsers.
	setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
